var render = function render(){var _vm=this,_c=_vm._self._c;return _c('graph-detail08-template',{attrs:{"board-ids":[242],"field-code":"facility","com-group-list":_vm.comGroupList,"graph1-title":"전체 (시설물) 비상조치계획수립 현황","graph2-title":"월별 (시설물) 비상조치계획수립 현황","graph3-title":"기간별 (시설물) 비상조치계획수립 현황","field-category-label":"시설물 구분","field-label":"시설물"}})
}
var staticRenderFns = []

export { render, staticRenderFns }